<template>
    <div>
        <v-card-title>Реактивация лидов</v-card-title>
        <v-card-text>
            <v-row align="center">
                <v-col cols="12" sm="2">
                    <v-text-field v-model.number="filter.limit" type="number" label="Лимит"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.source" :items="sources" item-value="id" item-text="name"
                              label="Источник" clearable></v-select>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.area" :items="areas" item-value="id" item-text="name"
                              label="Область права" clearable></v-select>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-btn color="primary" :loading="loading" @click="fetch()">Показать</v-btn>
                </v-col>
            </v-row>

            <v-skeleton-loader v-if="loading" type="table-row@5"></v-skeleton-loader>
            <v-data-table v-else :headers="headers" :items="items" item-key="requestId">
                <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="item in items" :key="item.requestId">
                        <td><a @click="editRequest(item.requestId)">{{ item.requestId }}</a></td>
                        <td>{{ item.userName }}</td>
                        <td>{{ item.userPhone }}</td>
                        <td>
                            <v-chip small :color="item.state.chipColor">{{ item.state.text }}</v-chip>
                        </td>
                        <td>{{ item.failureReason ? item.failureReason.text : '—' }}</td>
                        <td>
                            <v-chip v-if="item.score !== null && item.score !== undefined"
                                    small dark :color="$helper.aiScoreColor(item.score)"
                                    @click="showScoreDetail(item.requestId)">{{ item.score }}</v-chip>
                            <span v-else class="grey--text">—</span>
                        </td>
                        <td>{{ item.createdAtDate }}</td>
                        <td v-if="item.recommendations && item.recommendations.length">{{ item.recommendations[0] }}</td>
                        <td v-else>{{ item.hint }}</td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-card-text>

        <v-bottom-sheet
            v-model="dialog.requestEdit.modal"
            fullscreen
            scrollable
            persistent
            :retain-focus="false">
            <v-card style="background: none">
                <v-card-text style="height: 100vh;">
                    <RequestUpdatePage
                        v-if="editedRequest"
                        :id="editedRequest"
                        :key="editedRequestKey"
                        @closeAndUpdate="closeEditAndFetch"
                        @updated="fetch"
                        @fetchGrid="fetch"
                        @closeEdit="closeEdit">
                    </RequestUpdatePage>
                </v-card-text>
            </v-card>
        </v-bottom-sheet>

        <ScoreDetailDialog :dialog-visible="dialog.scoreDetail.modal"
                           :request-id="scoreDetailRequestId"
                           @close="dialog.scoreDetail.modal = false"
                           @recomputed="fetch()">
        </ScoreDetailDialog>
    </div>
</template>

<script>
import AiService from "../_services/AiService";
import SourceService from "../_services/SourceService";
import AreaService from "../_services/AreaService";
import RequestUpdatePage from "../requests/RequestUpdatePage";
import ScoreDetailDialog from "./ScoreDetailDialog";

export default {
    name: "AiReactivation",
    components: {RequestUpdatePage, ScoreDetailDialog},
    data() {
        return {
            loading: false,
            items: [],
            sources: [],
            areas: [],
            filter: {
                limit: 100,
                source: null,
                area: null
            },
            headers: [
                {text: 'ID', value: 'requestId'},
                {text: 'Клиент', value: 'userName'},
                {text: 'Телефон', value: 'userPhone'},
                {text: 'Статус', value: 'state'},
                {text: 'Причина отказа', value: 'failureReason'},
                {text: 'Скоринг', value: 'score'},
                {text: 'Дата', value: 'createdAtDate'},
                {text: 'Подсказка', value: 'hint'}
            ],
            dialog: {
                requestEdit: {
                    modal: false
                },
                scoreDetail: {
                    modal: false
                }
            },
            editedRequest: null,
            editedRequestKey: 0,
            scoreDetailRequestId: null
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            AiService.getReactivation(this.filter).then(data => {
                this.items = data;
                this.loading = false;
            });
        },
        editRequest(id) {
            this.editedRequest = id.toString();
            this.dialog.requestEdit.modal = true;
        },
        closeEdit() {
            this.dialog.requestEdit.modal = false;
            this.editedRequest = null;
            this.editedRequestKey++;
        },
        closeEditAndFetch() {
            this.closeEdit();
            this.fetch();
        },
        showScoreDetail(id) {
            this.scoreDetailRequestId = id;
            this.dialog.scoreDetail.modal = true;
        }
    },
    created() {
        this.fetch();
        SourceService.getAll().then(data => {
            this.sources = data;
        });
        AreaService.getAll().then(data => {
            this.areas = data;
        });
    }
};
</script>
